module.exports = __webpack_public_path__ + "static/bch-logo-grey-5bb1ac2600a0f0593f332ea685ec8fa6.png";